import React from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";
import webinarLogo from "@/assets/webinar-logo.jpeg";

const WebinarRegistered = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-100 via-blue-50 to-purple-50">
      {/* Header */}
      <header className="py-8 px-4">
        <div className="container mx-auto max-w-7xl">
          <div className="flex justify-center">
            <img 
              src={webinarLogo} 
              alt="GridBot DeFi Mastery" 
              className="w-full max-w-md object-contain"
            />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="container mx-auto max-w-3xl px-4 py-16">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 text-center">
          <div className="flex justify-center mb-6">
            <CheckCircle2 className="w-20 h-20 text-green-500" />
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-blue-900 mb-6">
            You're Registered!
          </h1>
          
          <div className="bg-blue-50 rounded-lg p-6 mb-8">
            <h2 className="text-2xl font-semibold text-blue-900 mb-4">
              Webinar Details
            </h2>
            <p className="text-xl text-slate-700 mb-2">
              <strong>Date:</strong> January 21, 2025
            </p>
            <p className="text-xl text-slate-700">
              <strong>Time:</strong> 7:00 PM GMT+3
            </p>
          </div>

          <div className="bg-purple-50 rounded-lg p-6 mb-8">
            <p className="text-lg text-slate-700">
              📧 <strong>Check your email for the calendar invite and webinar access link</strong>
            </p>
          </div>

          <p className="text-slate-600 mb-8">
            We've sent you a confirmation email with all the details you need to join the webinar.
            Make sure to add it to your calendar so you don't miss it!
          </p>

          <Link to="/webinar">
            <Button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg rounded-lg">
              Back to Webinar Page
            </Button>
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="text-center py-8 border-t border-slate-200">
        <p className="text-slate-500 text-sm">Powered by Leadpages</p>
      </footer>
    </div>
  );
};

export default WebinarRegistered;
